module.exports = __webpack_public_path__ + "img/cam_6_on.422cf608.png";